import { createSlice } from "@reduxjs/toolkit";
import { getPackageStickers } from "./thunk";

export interface IState {
  stickers: any;
  isStickerLoading: boolean;
  isStickerSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  stickers: null,
  isStickerLoading: false,
  isStickerSuccess: false,

  error: {},
};

const StickerSlice = createSlice({
  name: "Sticker",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Stickers
    builder.addCase(getPackageStickers.pending, (state: IState, action: any) => {
      state.isStickerLoading = true;
    });
    builder.addCase(getPackageStickers.fulfilled, (state: IState, action: any) => {
      state.stickers = action.payload.data;
      state.isStickerSuccess = true;
      state.isStickerLoading = false;
    });
    builder.addCase(getPackageStickers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isStickerSuccess = false;
      state.isStickerLoading = false;
    });
  },
});

export default StickerSlice.reducer;
